import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LookupDataService } from '../services/lookup-data.service';
import { LUSource } from '../models/luSource';
import { CallNumberModel } from '../models/callNumberModel';
import { SourceCallNoFilterComponent } from '../source-call-no-filter/source-call-no-filter.component';
import { GalleryTypeService } from '../services/gallery-type.service';
import { FilterParams, onlyUniqueByKey } from 'starbase-launcher';
import { ImageFile } from '../models/imageFile';
import { Router, ActivatedRoute } from '@angular/router';
import { ImageType } from '../models/imageType';
import { Data } from '@microsoft/applicationinsights-common';
import { NewTableEditorComponent, NewTableEditorUserViewOptions, ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { CallNoService } from '../services/call-no.service';
import { environment } from '../../environments/environment';
import { BreakpointService, BreakpointState } from '../breakpoint.service';
import { AppGlobalsService } from '../app-globals.service';

const LOADING_MESSAGE = 'Loading data...';

/** Source/Call No Search screen */
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('sourceCallNoCmp') sourceCallNoCmp: SourceCallNoFilterComponent;
  @ViewChild('microfilmTable') microfilmTable: NewTableEditorComponent<CallNumberModel>;
  message = '';
  messageClass: string;
  luSourceSubscription: Subscription; callNumbersSubscription: Subscription;
  sourceData: LUSource[] = [];
  callNumberData: CallNumberModel[] = [];
  chosenSourceCallNumber: CallNumberModel;
  searchFilters = new FilterParams<ImageFile>();
  galleryImageType = new ImageType();
  microfilmMode = false;
  microfilmColumns: ITableColumn[];
  microfilmViewOptions = new NewTableEditorUserViewOptions(false, true, true);
  private _subscription;
  isHandset: boolean = false;
  defaultColumns: ITableColumn[];
  level1: boolean;
  level2: boolean;
  dataLoaded: boolean = false;

  constructor(
    private imgTypeSvc: LookupDataService,
    private gallerySvc: GalleryTypeService,
    public callNoSvc: CallNoService,
    public sbCmpMsgSvc: StarbaseComponentMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private breakpointService: BreakpointService,
    private cd: ChangeDetectorRef,
    private appGlobalsSvc: AppGlobalsService) {
    this.chosenSourceCallNumber = this.gallerySvc.getCurrentCallNoSearch();
    this.galleryImageType.uid = 0; this.galleryImageType.typeOfImage = 'All';

    this.microfilmMode = this.route.snapshot.paramMap.get('search') === 'microfilm';
    this.microfilmColumns = this.microfilmMode ? this.isHandset ? CallNumberModel.microfilmColumnsMobile() : CallNumberModel.microfilmColumns() : this.isHandset ? CallNumberModel.callSearchColumnsMobile() : CallNumberModel.callSearchColumns();
   }

  ngOnInit() {

    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    )
    this.microfilmColumns = this.microfilmMode ? this.isHandset ? CallNumberModel.microfilmColumnsMobile() : CallNumberModel.microfilmColumns() : this.isHandset ? CallNumberModel.callSearchColumnsMobile() : CallNumberModel.callSearchColumns();
    this.defaultColumns = this.microfilmColumns;
  }

  ngAfterViewInit(): void {

    setTimeout(() => { 
      const el = document.getElementById('mainMenuBar');
      if (el) {
        el.scrollIntoView({ behavior: 'auto'});
        this.cd.markForCheck();
      } 
    }, 5);

    this.microfilmTable.dataFilterParams.addToFilter('ImagesExist', true);
    this.getLUSourceData();

  }

  ngOnDestroy() {
    if (this.luSourceSubscription) {
      this.luSourceSubscription.unsubscribe();
    }
    if (this.callNumbersSubscription) {
      this.callNumbersSubscription.unsubscribe();
    }
  }

  resetSearchParams(): void {
    this.searchFilters.resetFilters();
    this.sourceCallNoCmp.resetCallNumberDropdowns();
    this.sourceCallNoCmp.changeSource(null);
    this.chosenSourceCallNumber = new CallNumberModel();
    this.microfilmColumns = this.microfilmMode ? this.isHandset ? CallNumberModel.microfilmColumnsMobile() : CallNumberModel.microfilmColumns() : this.isHandset ? CallNumberModel.callSearchColumnsMobile() : CallNumberModel.callSearchColumns();
    //TODO: clear stored search & page
    this.appGlobalsSvc.clearStoredSearch();
    this.sourceCallNoCmp.focusOnDropdown();

  }

  public changedSourceSelection(e: LUSource) {
    if (!e) {
      this.chosenSourceCallNumber = null;
      this.searchFilters.replaceFilter('SourceCallNumberId', '');
      this.microfilmTable.dataFilterParams.replaceFilter('UID', '');
      this.microfilmTable.loadData();
      return;
    }
    if (!this.chosenSourceCallNumber) {
      this.chosenSourceCallNumber = new CallNumberModel();
    }
    this.chosenSourceCallNumber.lU_Source = e;
    this.chosenSourceCallNumber.lU_SourceUID = e.uid;
    this.getCallNumberData(this.chosenSourceCallNumber.lU_SourceUID);
    this.searchFilters.replaceFilter('SourceId', e.uid);
    this.searchFilters.replaceFilter('CallNumberL1', '');
    this.searchFilters.replaceFilter('CallNumberL2', '');
    this.searchFilters.replaceFilter('CallNumberL3', '');
    this.searchFilters.replaceFilter('CallNumberL4', '');
    this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL1', '');
    this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL2', '');
    this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL3', '');
    this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL4', '');
    this.microfilmTable.dataFilterParams.replaceFilter('LU_SourceUID', e.uid);
    this.microfilmTable.dataFilterParams.replaceFilter('ImagesExist', true);
    this.microfilmTable.loadData();
  }

  setcolumns(){
    const descriptionTooltipFunctionLvl1 = (data: CallNumberModel) => {
      return data.description;
    }
    const descriptionTooltipFunctionLvl2 = (data: CallNumberModel) => {
      return data.descriptionL2;
    }

    const lvl1Col = new TableColumn('callNumberL1', this.microfilmMode ? 'Publication Number' : 'Level 1' , ColumnDataTypes.string, true, false, true);
    lvl1Col.dataTooltip = descriptionTooltipFunctionLvl1;
    const lvl2Col = new TableColumn('callNumberL2', this.microfilmMode ? 'Roll #' : 'Level 2', ColumnDataTypes.string, false, false, false);
    lvl2Col.dataTooltip = descriptionTooltipFunctionLvl2;
    if(this.level1){
      if(this.level2){
        const columns = [
          lvl1Col,
          lvl2Col,
          new TableColumn('callNumberL3', 'Level 3', ColumnDataTypes.string, false, false, false),
          new TableColumn('descriptionL3', 'Level 3 Description', ColumnDataTypes.string, false, false, false),
          new TableColumn('callNumberL4', 'Level 4', ColumnDataTypes.string, false, false, false),
          new TableColumn('descriptionL4', 'Level 4 Description', ColumnDataTypes.string, false, false, false),
          new TableColumn('appears', '# of Images', ColumnDataTypes.number, false, false, false)
        ];
        columns[0].colWidth = '11%';
        columns[1].colWidth = '11%';
        columns[2].colWidth = '11%';
        columns[3].colWidth = '22%';
        columns[4].colWidth = '11%';
        columns[5].colWidth = '22%';
        columns[6].colWidth = '12%';
        this.microfilmColumns = columns;
      } else {
        const columns = [
          lvl1Col,
          new TableColumn('callNumberL2', this.microfilmMode ? 'Roll #' : 'Level 2', ColumnDataTypes.string, false, false, false),
          new TableColumn('descriptionL2', this.microfilmMode ? 'Roll Description' : 'Level 2 Description', ColumnDataTypes.string, false, false, false),
          new TableColumn('callNumberL3', 'Level 3', ColumnDataTypes.string, false, false, false),
          new TableColumn('descriptionL3', 'Level 3 Description', ColumnDataTypes.string, false, false, false),
          new TableColumn('appears', '# of Images', ColumnDataTypes.number, false, false, false)
        ];
        columns[0].colWidth = '12%';
        columns[1].colWidth = '12%';
        columns[2].colWidth = '25%';
        columns[3].colWidth = '12%';
        columns[4].colWidth = '25%';
        columns[5].colWidth = '14%';
        this.microfilmColumns = columns;
      }
    } else {
      this.microfilmColumns = this.defaultColumns;
    }
  }

  changeCallNumberSelection(selection: {callNumber: string; level: number}): void {
    if(selection.level <= 2){
      if(selection.level == 1){
        this.level1 = selection.level == 1 && selection.callNumber != ''
      }
      if(selection.level == 2){
        this.level2 = selection.level == 2 && selection.callNumber != ''
      }
      this.setcolumns();
    }
    this.searchFilters.replaceFilter('CallNumberL' + selection.level, selection.callNumber);
    this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL' + selection.level, selection.callNumber);
  }

  readSourceCallEmitted(data): void {
    if (!data || !data.length) {
      const temp = this.chosenSourceCallNumber.lU_Source;
      this.chosenSourceCallNumber = new CallNumberModel();
      if (temp) {
        this.chosenSourceCallNumber.lU_Source = temp;
        this.chosenSourceCallNumber.lU_SourceUID = temp.uid;
      }
      this.searchFilters.replaceFilter('CallNumberL1', '');
      this.searchFilters.replaceFilter('CallNumberL2', '');
      this.searchFilters.replaceFilter('CallNumberL3', '');
      this.searchFilters.replaceFilter('CallNumberL4', '');
      this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL1', '');
      this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL2', '');
      this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL3', '');
      this.microfilmTable.dataFilterParams.replaceFilter('CallNumberL4', '');
      this.microfilmTable.loadData();
    } else {
      this.microfilmTable.loadData();
      // clear old filter, if any
      //this.searchFilters.replaceFilter('SourceCallNumberId', '');
      // check if complete CallNumber model. If not, then we are using wildcards. Match 'All' in Call# Levels past 1...
      //if (Array.isArray(data)) { // wildcard signal
      //  data.forEach(s =>
      //    this.searchFilters.addToFilter('SourceCallNumberId', s.uid.toString())
      //  );
      //  this.microfilmTable.loadData();
      //} else if (data) {
      //  this.searchFilters.replaceFilter('SourceCallNumberId', data.toString());
      //  this.microfilmTable.loadData();
      //}
    }
    const callNo = new CallNumberModel().deserialize(this.chosenSourceCallNumber) as CallNumberModel;
    callNo.callNumberL1 = this.sourceCallNoCmp ? this.sourceCallNoCmp.callNumberL1Selection : this.chosenSourceCallNumber.callNumberL1;
    callNo.callNumberL2 = this.sourceCallNoCmp ? this.sourceCallNoCmp.callNumberL2Selection : this.chosenSourceCallNumber.callNumberL2;
    callNo.callNumberL3 = this.sourceCallNoCmp ? this.sourceCallNoCmp.callNumberL3Selection : this.chosenSourceCallNumber.callNumberL3;
    callNo.callNumberL4 = this.sourceCallNoCmp ? this.sourceCallNoCmp.callNumberL4Selection : this.chosenSourceCallNumber.callNumberL4;
    this.gallerySvc.setCurrentCallNoSearch(callNo);
  }

  executeSearch(): void {
    this.gallerySvc.setGalleryType(
      this.galleryImageType
    );
    this.searchFilters.rpp = 35;
    this.gallerySvc.setCurrentLibraryFilters(this.searchFilters);
    if (!this.chosenSourceCallNumber.uid) {
      this.chosenSourceCallNumber.uid = 1;
    }
    this.gallerySvc.setCurrentFilterOptions('SourceCallNo', [this.chosenSourceCallNumber]);
    this.router.navigate(['/library']);
  }

  viewCallNoRecords(callNo: CallNumberModel): void {
    this.appGlobalsSvc.setStoredSearch(this.microfilmTable.dataFilterParams);
    this.gallerySvc.setGalleryType(
      this.galleryImageType
    );
    this.searchFilters.rpp = 35;
    // this.searchFilters.replaceFilter('SourceCallNumberId', callNo.uid.toString());
    this.searchFilters.replaceFilter('SourceId', callNo.lU_SourceUID);
    this.searchFilters.replaceFilter('CallNumberL1', callNo.callNumberL1);
    this.searchFilters.replaceFilter('CallNumberL2', callNo.callNumberL2 ? callNo.callNumberL2 : '');
    this.searchFilters.replaceFilter('CallNumberL3', callNo.callNumberL3 ? callNo.callNumberL3 : '');
    this.searchFilters.replaceFilter('CallNumberL4', callNo.callNumberL4 ? callNo.callNumberL4 : '');
    this.gallerySvc.setCurrentLibraryFilters(this.searchFilters);
    this.gallerySvc.setCurrentFilterOptions('SourceCallNo', [callNo]);
    this.router.navigate(['/library']);
  }

  private getLUSourceData(): void {
    this.message = LOADING_MESSAGE;
    // eslint-disable-next-line max-len
    this.luSourceSubscription = this.imgTypeSvc.getAllRequisiteData<LUSource>(this.imgTypeSvc.getLUSourcesUrl + (this.microfilmMode ? '?forMicrofilm=true' : '')).subscribe(l => {
      this.sourceData = onlyUniqueByKey(l, 'source');
      this.message = 'Choose search parameters:';
      this.messageClass = '';
      if (this.microfilmMode) {
        //this.sourceCallNoCmp.changeSource(this.chosenSourceCallNumber.lU_Source);
      }
      this.setLoadedData();
    }, () => {
      this.message = 'Error when loading the Source lookup data. Please reload the system.';
      this.messageClass = 'badge badge-danger';
    });
    
  }
  private getCallNumberData(sourceId: number): void {
    this.message = LOADING_MESSAGE;
    this.microfilmColumns = this.microfilmMode ? this.isHandset ? CallNumberModel.microfilmColumnsMobile() : CallNumberModel.microfilmColumns() : this.isHandset ? CallNumberModel.callSearchColumnsMobile() : CallNumberModel.callSearchColumns();
    this.callNumbersSubscription = this.imgTypeSvc.getCallNumberBySourceFromServer(sourceId, false).subscribe(
      d => {
        this.callNumberData = d;
        this.sourceCallNoCmp.resetCallNumberDropdowns();
        this.message = 'Choose search parameters:';
        this.messageClass = '';
        if (!this.callNumberData.length) {
          this.searchFilters.clearFilterArray();
          this.searchFilters.addToFilter('SourceId', sourceId.toString());
        } else {
          this.searchFilters.replaceFilter('SourceId', '');
        }
        if (this.microfilmMode && this.chosenSourceCallNumber.callNumberL1) {
          var tempArr = [this.chosenSourceCallNumber];
          this.sourceCallNoCmp.callNumberData = tempArr;
          this.sourceCallNoCmp.callNumberL1DisplayData = [];
          this.sourceCallNoCmp.callNumberL1Selection = this.chosenSourceCallNumber.callNumberL1;
          this.sourceCallNoCmp.callNumberL2Selection = this.chosenSourceCallNumber.callNumberL2;
          this.sourceCallNoCmp.callNumberL3Selection = this.chosenSourceCallNumber.callNumberL3;
          this.sourceCallNoCmp.callNumberL4Selection = this.chosenSourceCallNumber.callNumberL4;
          this.sourceCallNoCmp.changeCallNumberSelections();
        }
      },
      () => {
        this.message = 'Error when loading the call number data. Please reload the system.';
        this.messageClass = 'badge badge-danger';
      });

  }

  setLoadedData() {
    this.chosenSourceCallNumber = new CallNumberModel();
    this.chosenSourceCallNumber.uid = -1
    var id = 0;
    var tempFilterParams = this.appGlobalsSvc.loadStoredSearch();
    this.microfilmTable.dataFilterParams = this.appGlobalsSvc.loadStoredSearch();
    if(this.microfilmMode){
      this.chosenSourceCallNumber.lU_SourceUID = environment.nationalArchivesId;
      this.chosenSourceCallNumber.lU_Source = this.sourceData.filter(x => x.uid === this.chosenSourceCallNumber.lU_SourceUID)[0];
      tempFilterParams.replaceFilter('LU_SourceUID', this.chosenSourceCallNumber.lU_SourceUID);
      this.microfilmTable.dataFilterParams.replaceFilter('LU_SourceUID', this.chosenSourceCallNumber.lU_SourceUID);
    }
    var items = tempFilterParams.filters.length;
    if(items == 0){
        this.finishedLoading();
    }
    var runCount = 0;
    tempFilterParams.filters.forEach(x => {
      switch(x[0]){
        case "LU_SourceUID":
          var s = this.sourceData.find(y => y.uid == x[1]);
          id = x[1];
          this.changedSourceSelection(s);
          this.chosenSourceCallNumber.source = s.source;
          break;
        case "CallNumberL1":
          var select = {callNumber: x[1], level: 1};
          this.changeCallNumberSelection(select);
          this.chosenSourceCallNumber.callNumberL1 = x[1];
          break;
        case "CallNumberL2":
          var select = {callNumber: x[1], level: 2};
          this.changeCallNumberSelection(select);
          this.chosenSourceCallNumber.callNumberL2 = x[1];
          break;
        case "CallNumberL3":
          var select = {callNumber: x[1], level: 3};
          this.changeCallNumberSelection(select);
          this.chosenSourceCallNumber.callNumberL3 = x[1];
          break;
        case "CallNumberL4":
          var select = {callNumber: x[1], level: 4};
          this.changeCallNumberSelection(select);
          this.chosenSourceCallNumber.callNumberL4 = x[1];
          break;
      }
      runCount++;
    })
    if(items == runCount){
      this.finishedLoading();
    }
  }

  finishedLoading() {
    this.dataLoaded = true;
    console.log(this.chosenSourceCallNumber)
    var obj = Object.assign(new CallNumberModel,this.chosenSourceCallNumber)
    setTimeout(() => {
      console.log("Delayed for 1 second.");
      this.sourceCallNoCmp.fillInCallNum(obj);
      //this.microfilmTable.loadData();
    }, 1000);
  }
}
